import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  canAccessLeaveRequestManagement,
  canAccessRoute,
} from "../utils/rolePermissions";
import PTSNavigationRoutes from "../utils/navigationRoutes";

interface ProtectedPTSRouteProps {
  children: React.ReactNode;
}

/**
 * Component that protects PTS routes based on user role permissions
 * Redirects to Employee Dashboard if user doesn't have access
 */
export const ProtectedPTSRoute = ({ children }: ProtectedPTSRouteProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentRoute = `${location.pathname}${location.search}`;
    const ptsRoute = currentRoute;

    if (ptsRoute && !canAccessRoute(ptsRoute)) {
      const isLeaveRequestRoute = location.pathname.includes(
        PTSNavigationRoutes.LEAVE_REQUESTS
      );

      if (isLeaveRequestRoute && !canAccessLeaveRequestManagement()) {
        navigate(`${PTSNavigationRoutes.LEAVE_REQUESTS}?tab=employee`, {
          replace: true,
        });
        return;
      }

      navigate(PTSNavigationRoutes.EMPLOYEE_DASHBOARD, {
        replace: true,
      });
    }
  }, [location.pathname, location.search, navigate]);

  return children;
};
